import { Validators } from "@angular/forms"
import moment = require("moment");
import { ETableActionType, ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants";
import { IFormKey } from "src/app/modules/shared/models/forms"

export enum ESpecificBeneficiaryType {
    PERSONA_FISICA = 'Persona fisica',
    PERSONA_GIURIDICA = 'Persona giuridica',
}

export enum BasicAnswer {
    SI = 'SI',
    NO = 'NO'
}

export const beneficiary_form_template_previdential = {
    beneficiaryType: null
}

export const beneficiary_form_validators_previdential = {
    beneficiaryType: [Validators.required]
}


export const beneficiary_form_template = {
    beneficiaryType: null,
    specificBeneficiaryType: null
}

export const beneficiary_form_validators = {
    beneficiaryType: [Validators.required],
    specificBeneficiaryType: [Validators.required]
}

export const beneficiary_form_keys: IFormKey[] = [
    {
        id: 'beneficiary-isv-field',
        label: 'Selezione beneficiari',
        controlName: 'beneficiaryType',
        css: 'mt-2 col-6',
        type: 'SELECT',
        options: []
    },
    {
        id: 'specific-beneficiary-type-isv-field',
        label: 'Tipologia Persona',
        controlName: 'specificBeneficiaryType',
        css: 'mt-2 col-6',
        type: 'SELECT',
        options: [
            {
                key: ESpecificBeneficiaryType.PERSONA_FISICA,
                value: ESpecificBeneficiaryType.PERSONA_FISICA
            },
            {
                key: ESpecificBeneficiaryType.PERSONA_GIURIDICA,
                value: ESpecificBeneficiaryType.PERSONA_GIURIDICA
            }
        ],
        hidden: true
    }
];

export const beneficiary_form_keys_payer: IFormKey[] = [
    {
        id: 'beneficiary-isv-field',
        label: 'Selezione pagatore',
        controlName: 'beneficiaryType',
        css: 'mt-2 col-6',
        type: 'SELECT',
        options: []
    },
    {
        id: 'specific-beneficiary-type-isv-field',
        label: 'Tipologia Persona',
        controlName: 'specificBeneficiaryType',
        css: 'mt-2 col-6',
        type: 'SELECT',
        options: [
            {
                key: ESpecificBeneficiaryType.PERSONA_FISICA,
                value: ESpecificBeneficiaryType.PERSONA_FISICA
            },
            {
                key: ESpecificBeneficiaryType.PERSONA_GIURIDICA,
                value: ESpecificBeneficiaryType.PERSONA_GIURIDICA
            }
        ],
        hidden: true
    }
];

export const individual_form_template = {
    surname: null,
    name: null,
    taxCode: null,
    birthDate: null,
    relationshipDegree: null,
    insuredLink: null
}

export const individual_form_template_previdential = {
    surname: null,
    name: null,
    taxCode: null,
    birthDate: null,
    relationshipDegree: null,
    insuredLink: null,
    percentuale: null,
    sesso: null

    //vip: null,
    //personalData: null
}

export const individual_form_template_previdential_payer = {
    surname: null,
    name: null,
    taxCode: null,
    birthDate: null,
    sesso: null,
}


export const individual_form_validators = {
    surname: [Validators.required],
    name: [Validators.required],
    taxCode: [Validators.required, Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/)],
    birthDate: [Validators.required],
    relationshipDegree: [Validators.required],
    insuredLink: [Validators.required]
}

export const individual_form_payer_keys: IFormKey[] = [{
        id: 'individual-surname-field',
        controlName: 'surname',
        label: 'Cognome',
        css: 'col-4'
    },
    {
        id: 'individual-name-field',
        controlName: 'name',
        label: 'Nome',
        css: 'col-4'
    },
    {
        id: 'individual-taxcode-field',
        controlName: 'taxCode',
        label: 'Codice fiscale',
        css: 'col-4',
        uppercase: true
    },
    {
        id: 'individual-birthDate-field',
        controlName: 'birthDate',
        label: 'Data di nascita',
        type: 'DATEPICKER',
        maxDate: moment(),
        css: 'col-4'
    },
    {
        id: 'individual-sesso-field',
        controlName: 'sesso',
        label: 'sesso',
        css: 'col-4',
        type: 'SELECT',
        options: [
            {
                key: 'M',
                value: 'Maschio'
            },
            {
                key: 'F',
                value: 'Femmina'
            },
        ]
    }
]

export const individual_form_keys: IFormKey[] = [
    {
        id: 'individual-surname-field',
        controlName: 'surname',
        label: 'Cognome',
        css: 'col-4'
    },
    {
        id: 'individual-name-field',
        controlName: 'name',
        label: 'Nome',
        css: 'col-4'
    },
    {
        id: 'individual-taxcode-field',
        controlName: 'taxCode',
        label: 'Codice fiscale',
        css: 'col-4',
        uppercase: true
    },
    {
        id: 'individual-birthDate-field',
        controlName: 'birthDate',
        label: 'Data di nascita',
        type: 'DATEPICKER',
        maxDate: moment(),
        css: 'col-4'
    },
    {
        id: 'individual-relationshipDegree-field',
        controlName: 'relationshipDegree',
        label: 'Grado di parentela con il contraente',
        type: 'SELECT',
        options: [],
        css: 'col-4'
    },
    {
        id: 'individual-insuredLink-field',
        controlName: 'insuredLink',
        label: 'Legame Assicurato Beneficiario',
        type: 'SELECT',
        options: [],
        css: 'col-4'
    }
];

export const individual_form_validators_previdential_payer = {
    surname: [Validators.required],
    name: [Validators.required],
    taxCode: [Validators.required, Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/)],
    birthDate: [Validators.required]
}


export const individual_form_validators_previdential = {
    surname: [Validators.required],
    name: [Validators.required],
    taxCode: [Validators.required, Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/)],
    birthDate: [Validators.required],
    relationshipDegree: [Validators.required],
    sesso: [Validators.required],
    percentuale: [Validators.required]
    //vip: [Validators.required],
    //personalData: [Validators.required]
}

export const individual_form_keys_previdential: IFormKey[] = [
    {
        id: 'individual-surname-field',
        controlName: 'surname',
        label: 'Cognome',
        css: 'col-4'
    },
    {
        id: 'individual-name-field',
        controlName: 'name',
        label: 'Nome',
        css: 'col-4'
    },
    {
        id: 'individual-sesso-field',
        controlName: 'sesso',
        label: 'sesso',
        css: 'col-4',
        type: 'SELECT',
        options: [
            {
                key: 'M',
                value: 'Maschio'
            },
            {
                key: 'F',
                value: 'Femmina'
            },
        ]
    },
    {
        id: 'individual-taxcode-field',
        controlName: 'taxCode',
        label: 'Codice fiscale',
        css: 'col-4',
        uppercase: true
    },
    {
        id: 'individual-birthDate-field',
        controlName: 'birthDate',
        label: 'Data di nascita',
        type: 'DATEPICKER',
        maxDate: moment(),
        css: 'col-4'
    },
    {
        id: 'individual-relationshipDegree-field',
        controlName: 'relationshipDegree',
        label: 'Grado di parentela con il contraente',
        type: 'SELECT',
        options: [],
        css: 'col-4'
    },
    {
        label: 'Percentuale beneficiario',
        css: 'col-4',
        type: 'NUMBER',
        id: 'percentuale',
        controlName: 'percentuale',
    }
    /*{
        id: 'individual-isVip',
        label: 'Vip',
        controlName: 'vip',
        css: 'mt-2 col-4',
        type: 'SELECT',
        options: [
            {
                key: BasicAnswer.SI,
                value: BasicAnswer.SI
            },
            {
                key: BasicAnswer.NO,
                value: BasicAnswer.NO
            }
        ]
    },
    {
        id: 'individual-personalData',
        label: 'Dati Personali',
        controlName: 'personalData',
        css: 'mt-2 col-4',
        type: 'SELECT',
        options: [
            {
                key: BasicAnswer.SI,
                value: BasicAnswer.SI
            },
            {
                key: BasicAnswer.NO,
                value: BasicAnswer.NO
            }
        ]
    }*/
]

export const third_party_registry_form_template = {
    surname: null,
    name: null,
    taxCode: null
}

export const third_party_registry_form_validators = {
    surname: [Validators.required],
    name: [Validators.required],
    taxCode: [Validators.required, Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/)]
}

export const third_party_registry_form_keys: IFormKey[] = [
    {
        id: 'individual-surname-field',
        controlName: 'surname',
        label: 'Cognome',
        css: 'col-4'
    },
    {
        id: 'individual-name-field',
        controlName: 'name',
        label: 'Nome',
        css: 'col-4'
    },
    {
        id: 'individual-taxcode-field',
        controlName: 'taxCode',
        label: 'Codice fiscale',
        css: 'col-4',
        uppercase: true
    }
];

export const birth_form_template = {
    place: {value: null, disabled: true},
    province: {value: null, disabled: true},
    country: null,
}

export const birth_form_validators = {
    place: [Validators.required],
    province: [Validators.required],
    country: [Validators.required],
}

export const birth_form_keys: IFormKey[] = [
    {
        id: 'country-isv-field',
        label: 'Nazione',
        controlName: 'country',
        css: 'col-4',
        type: 'SELECT',
        options: [],
    },
    {
        id: 'province-isv-field',
        label: 'Provincia',
        controlName: 'province',
        css: 'col-4',
        type: 'SELECT',
        options: [],
    },
    {
        id: 'place-isv-field',
        label: 'Città',
        controlName: 'place',
        css: 'col-4',
        type: 'SELECT',
        options: [],
    }
]


export const birth_form_keys_: IFormKey[] = [
    {
        id: 'country-isv-field',
        label: 'Nazione',
        controlName: 'country',
        css: 'col-4',
        type: 'SELECT',
        options: [],
    },
    {
        id: 'province-isv-field',
        label: 'Provincia',
        controlName: 'province',
        css: 'col-4',
        type: 'SELECT',
        options: [],
    },
    {
        id: 'place-isv-field',
        label: 'Città',
        controlName: 'place',
        css: 'col-4',
        type: 'SELECT',
        options: [],
    }
]

export const address_form_template = {
    country: null,
    place: {value: null, disabled: true},
    province: {value: null, disabled: true},
    postalCode: {value: null, disabled: true},
    address: {value: null, disabled: true}
}

export const address_form_validators = {
    country: [Validators.required],
    place: [Validators.required],
    province: [Validators.required],
    postalCode: [Validators.required, Validators.pattern(/^\d{5}$/)],
    address: [Validators.required]
}

export const address_form_keys: IFormKey[] = [
    {
        id: 'country-field',
        label: 'Stato',
        controlName: 'country',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'province-field',
        label: 'Provincia',
        controlName: 'province',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'place-field',
        label: 'Città',
        controlName: 'place',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'postalCode-field',
        label: 'CAP',
        controlName: 'postalCode',
        css: 'col-4'
    },
    {
        id: 'address-field',
        label: 'Indirizzo',
        controlName: 'address',
        css: 'col-4'
    }
];

export const address_enabling_map = {
    country: 'province',
    province: 'place',
    place: 'postalCode',
    postalCode: 'address'
}

export const contact_form_template = {
    phone: null,
    email: null
}

export const contact_form_validators = {
    phone: [Validators.required],
    email: [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]
}

export const contact_form_keys: IFormKey[] = [
    {
        id: 'contact-phone-isv-field',
        label: 'Telefono',
        controlName: 'phone',
        css: 'col-4'
    },
    {
        id: 'contact-email-isv-field',
        label: 'Email',
        controlName: 'email',
        css: 'col-4'
    }
];

export const legal_form_template = {
    vatCode: null,
    businessName: null,
    relationshipDegree: null,
    insuredLink: null,
    birthDate: null
}

export const legal_form_template_previdential = {
    vatCode: null,
    businessName: null,
    relationshipDegree: null,
    percentuale: null
}

export const legal_form_validators_previdential = {
    vatCode: [Validators.required],
    businessName: [Validators.required],
    relationshipDegree: [Validators.required],
    percentuale: [Validators.required]
}

export const legal_form_validators = {
    vatCode: [Validators.required],
    businessName: [Validators.required],
    relationshipDegree: [Validators.required],
    insuredLink: [Validators.required],
    percentuale: [Validators.required]
}


export const legal_form_keys_previdential: IFormKey[] = [
    {
        id: 'legal-businessName-field',
        controlName: 'businessName',
        label: 'Ragione sociale',
        css: 'col-4'
    },
    {
        id: 'individual-vatCode-field',
        controlName: 'vatCode',
        label: 'Partita IVA',
        css: 'col-4'
    },
    {
        label: 'Percentuale beneficiario',
        css: 'col-4',
        type: 'NUMBER',
        id: 'percentuale',
        controlName: 'percentuale',
    },
    {
        id: 'individual-relationshipDegree-field',
        controlName: 'relationshipDegree',
        label: 'Grado di parentela con il contraente',
        type: 'SELECT',
        options: [],
        css: 'col-4'
    }
];

export const legal_form_keys: IFormKey[] = [
    {
        id: 'legal-businessName-field',
        controlName: 'businessName',
        label: 'Ragione sociale',
        css: 'col-4'
    },
    {
        id: 'individual-vatCode-field',
        controlName: 'vatCode',
        label: 'Partita IVA',
        css: 'col-4'
    },
    {
        id: 'individual-relationshipDegree-field',
        controlName: 'relationshipDegree',
        label: 'Grado di parentela con il contraente',
        type: 'SELECT',
        options: [],
        css: 'col-4'
    },
    {
        id: 'individual-insuredLink-field',
        controlName: 'insuredLink',
        label: 'Legame Assicurato Beneficiario',
        type: 'SELECT',
        options: [],
        css: 'col-4'
    },
    {
        id: 'individual-birthDate-field',
        controlName: 'birthDate',
        label: 'Data di costituzione',
        type: 'DATEPICKER',
        maxDate: moment(),
        css: 'col-4'
    }
];

export const search_subject_form_keys_benficiary_type_validators = {
    specificBeneficiaryType: null,
}

export const search_subject_form_benficiary_type_template = {
    specificBeneficiaryType: null,
}

export const search_subject_form_keys_benficiary_type: IFormKey[] = [
    {
        id: 'specific-beneficiary-type-isv-field',
        label: 'Tipologia Persona',
        controlName: 'specificBeneficiaryType',
        css: 'col-4',
        type: 'SELECT',
        options: [
            {
                key: ESpecificBeneficiaryType.PERSONA_FISICA,
                value: ESpecificBeneficiaryType.PERSONA_FISICA
            },
            {
                key: ESpecificBeneficiaryType.PERSONA_GIURIDICA,
                value: ESpecificBeneficiaryType.PERSONA_GIURIDICA
            }
        ]
    }
]

export const search_subject_form_keys_previdential: IFormKey[] = [
    {
        id: 'cognome-field',
        label: 'Cognome',
        controlName: 'cognome',
        css: 'col-4',
        type: 'INPUT',
    },
    {
        id: 'nome-field',
        label: 'Nome',
        controlName: 'nome',
        css: 'col-4',
        type: 'INPUT',
    },
    {
        id: 'data-field',
        label: 'Data di nascita',
        controlName: 'dataNascita',
        css: 'col-4',
        type: 'DATEPICKER',
        maxDate: moment(),
    },
    {
        id: 'cf-field',
        label: 'Codice Fiscale',
        controlName: 'codiceFiscale',
        css: 'col-4',
        type: 'INPUT',
        uppercase: true
    }
]

export const search_subject_legal_form_keys_previdential: IFormKey[] = [
    {
        id: 'ragione-field',
        label: 'Ragione Sociale',
        controlName: 'ragioneSociale',
        css: 'col-4',
        type: 'INPUT'
    },
    {
        id: 'partita-iva-field',
        label: 'Partita IVA',
        controlName: 'partitaIVA',
        css: 'col-4',
        type: 'INPUT'
    },
    {
        id: 'codice-fiscale-field',
        label: 'Codice Fiscale',
        controlName: 'codiceFiscale',
        css: 'col-4',
        type: 'INPUT',
        uppercase: true
    }
]

export const search_subject_legal_form_template_previdential = {
    ragioneSociale: null,
    partitaIVA: null,
    codiceFiscale: null
}

export const search_subject_legal_form_validators_previdential = {
    ragioneSociale: null,
    partitaIVA: null,
    codiceFiscale: null
}

export const search_subject_form_template_previdential = {
    nome: null,
    cognome: null,
    dataNascita: null,
    codiceFiscale: null,
    ragioneSociale: null
}

export const search_subject_form_validators_previdential = {
    nome: null,
    cognome: null,
    dataNascita: null,
    codiceFiscale: null,
    ragione: null,
    vip: null,
    personalData: null
}

export interface SearchSubject {
    idAnagrafico?: string;
    nome?: string;
    cognome?: string;
    dataNascita?: Date;
    codiceFiscale?: string;
    ragioneSociale?: string;
    naturaGiuridica?: string;
    indirizzoNascita?: Locality
    naturaGiurifica?: 'F' | 'G';
    sesso?: 'M' | 'F';
    showIcon?: boolean;
    relazioneDescrizione?: string;
    perc_Beneficio?: number;
    nazioneNascita?: string;
    localitaProvincia?: string;
    provinciaNascita?: string;
    localitaNascita?: string
    partitaIVA?: string
    localita?: string
    cap?: string
    via?: string
}


export interface Locality {
    localita?: string;
    provincia?: string;
    nazione?: string;
    codiceNazione?: string;
}

export interface SearchSubjectResponse {
    nome: string;
    cognome: string;
    codiceFiscale: string;
    dataNascita: Date;
    ragioneSociale?: string;
    partitaIVA?: string;
}

export const dashboard_table_keys_previdential: ITableKey[] = [
    {
        key: 'nome',
        label: 'nome',
        sortable: true,
        type: 'TOOLTIP'
    },
    {
        key: 'cognome',
        label: 'cognome',
        sortable: true,
        type: 'TOOLTIP'
    },
    {
        key: 'dataNascita',
        label: 'dataNascita',
        pipe: {
            key: 'date',
            value: null
        }
    },
    {
        key: 'codiceFiscale',
        label: 'codiceFiscale',
        sortable: true,
        type: 'TOOLTIP'
    },
      {
    key: ETableActionType.OPERATION,
    label: '',
    type: 'ACTION_ICON',
    actionIcon: 'visibility',
    color: 'primary',
    tooltipText: 'Visualizza operazione',
    showIconFieldName: 'showOperation',
  },
]

export const dashboard_table_keys_previdential_legal: ITableKey[] = [
    {
        key: 'ragioneSociale',
        label: 'Ragione Sociale',
        sortable: true,
        type: 'TOOLTIP'
    },
    {
        key: 'partitaIVA',
        label: 'Partita IVA',
        sortable: true,
        type: 'TOOLTIP'
    },  
    {
        key: 'descrizioneFormaSocietaria',
        label: 'Forma societaria',
        sortable: true,
        type: 'TOOLTIP'
    },
    {
        key: 'codiceFiscale',
        label: 'codiceFiscale',
        sortable: true,
        type: 'TOOLTIP'
    },
    {
    key: ETableActionType.OPERATION,
    label: '',
    type: 'ACTION_ICON',
    actionIcon: 'visibility',
    color: 'primary',
    tooltipText: 'Visualizza operazione',
    showIconFieldName: 'showOperation',
  },
]
